var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPesetaSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 168H341.574C329.881 91.213 264 32 184 32H88C65.909 32 48 49.909 48 72V168H24C10.75 168 0 178.75 0 192S10.75 216 24 216H48V456C48 469.25 58.75 480 72 480S96 469.25 96 456V352H184C264 352 329.881 292.787 341.574 216H360C373.25 216 384 205.25 384 192S373.25 168 360 168ZM96 80H184C237.496 80 282.229 117.768 293.268 168H96V80ZM184 304H96V216H293.268C282.229 266.232 237.496 304 184 304Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesetaSign);
export default __webpack_public_path__ + "static/media/peseta-sign.b7e96911b352b249f22b3b1e304d9806.svg";
export { ForwardRef as ReactComponent };